import { useEffect, useRef, useState } from 'react'

const UploadInvoiceModal = ({ show, onClose, onSubmit, isLoading }) => {
  const fileInputRef = useRef(null)
  const [file, setFile] = useState(null)
  const [isDragActive, setIsDragActive] = useState(false)
  const [error, setError] = useState('')

  const isPdfFile = (selectedFile) => selectedFile?.type === 'application/pdf'

  const reset = () => {
    setFile(null)
    setIsDragActive(false)
    setError('')
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  // Limpiar el estado cada vez que el modal se cierra, incluso cuando el cierre
  // lo dispara el padre (p. ej. tras una subida correcta) y no handleClose.
  useEffect(() => {
    if (!show) reset()
  }, [show])

  const handleClose = () => {
    reset()
    onClose()
  }

  const assignFile = (selectedFile) => {
    if (!selectedFile) return
    if (!isPdfFile(selectedFile)) {
      setError('Solo se permiten archivos PDF.')
      setFile(null)
      return
    }
    setError('')
    setFile(selectedFile)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!file) {
      setError('Debes seleccionar un archivo PDF.')
      return
    }
    onSubmit({ file })
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setIsDragActive(false)
    const droppedFile = e.dataTransfer.files?.[0]
    assignFile(droppedFile)
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    setIsDragActive(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    setIsDragActive(false)
  }

  if (!show) return null

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ background: 'rgba(0,0,0,0.45)', zIndex: 1050 }}
      onClick={(e) => { if (e.target === e.currentTarget) handleClose() }}
    >
      <div
        className="bg-white rounded shadow"
        style={{ width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto', margin: '16px' }}
      >
        {/* Header */}
        <div
          className="d-flex justify-content-between align-items-center px-4 py-3"
          style={{ borderBottom: '1px solid #f3f4f6' }}
        >
          <p className="mb-0" style={{ fontWeight: '700', fontSize: '15px', color: '#111827' }}>
            Subir factura
          </p>
          <button
            type="button"
            onClick={handleClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#6b7280', lineHeight: 1 }}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 d-flex flex-column gap-3">
          <div
            className="rounded p-4 text-center"
            style={{
              border: `2px dashed ${isDragActive ? '#7c3aed' : '#d1d5db'}`,
              background: isDragActive ? '#faf5ff' : '#f9fafb',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
            }}
            onClick={() => fileInputRef.current?.click()}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept="application/pdf"
              className="d-none"
              onChange={(e) => assignFile(e.target.files?.[0])}
            />
            <p className="mb-1" style={{ fontWeight: 700, color: '#111827' }}>
              Arrastra y suelta tu factura PDF aqui
            </p>
            <p className="mb-0" style={{ fontSize: '13px', color: '#6b7280' }}>
              o haz clic para seleccionar un archivo
            </p>
            {file && (
              <p className="mb-0 mt-3" style={{ fontSize: '13px', color: '#111827', fontWeight: 600 }}>
                Archivo seleccionado: {file.name}
              </p>
            )}
          </div>
          {error && <span className="text-danger" style={{ fontSize: '12px' }}>{error}</span>}

          <div className="d-flex justify-content-end gap-2 pt-2">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-white border border-on-bg-primary px-4"
              style={{ fontSize: '14px' }}
              disabled={isLoading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-bg-CTA-primary px-4"
              style={{ fontSize: '14px' }}
              disabled={isLoading || !file}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" />
              ) : (
                'Subir factura'
              )}
            </button>
          </div>

        </form>
      </div>
    </div>
  )
}

export default UploadInvoiceModal
